<opac-dialog
  #dialog
  size="small"
  [title]="'user.challenges.monthlyTitle' | translate"
  (opened)="updateInitialValue()"
  (closed)="closeModal()">
  <p class="subtitle">{{'user.challenges.monthlyGoalText' | translate}}</p>

  <section>
    <p>{{ 'user.challenges.monthlyInfoTitle' | translate }}</p>

    <form [formGroup]="monthlyChallengeFormGroup">
      <div class="controls">
        <opac-button class="control-button">
          <opac-icon slot="only-icon" (click)="removeTarget()" [icon]="'remove_circle'"></opac-icon>
        </opac-button>

        <input
          (blur)="checkValue()"
          (input)="modifyValue()"
          formControlName="target"
          type="number"
          [value]="1"
          [min]="MIN_VALUE"
          [max]="MAX_VALUE"
          [step]="1"
          [placeholder]="1" />

        <opac-button class="control-button">
          <opac-icon slot="only-icon" (click)="addTarget()" [icon]="'add_circle'"></opac-icon>
        </opac-button>
      </div>
    </form>
  </section>

  <opac-button slot="actions" (click)="createChallenge()">
    {{ (initialValue() !== undefined ? 'button.update' : 'button.create') | translate }}
  </opac-button>
</opac-dialog>
